"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigHelper = void 0;
class ConfigHelper {
    static getEnvVariable(variable) {
        return process && process.env ? process.env[variable] : undefined;
    }
}
exports.ConfigHelper = ConfigHelper;
